import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import { SearchIcon } from 'icons'

type LocationSearchProps = {
  inline?: boolean
  address: string | null
  onDone?: (address: string) => void
}

const LocationSearch: FC<LocationSearchProps> = (props) => {
  const { t } = useTranslation('common')

  return (
    <fieldset className="relative flex rounded-sm ring-1 ring-grey-3 transition-shadow focus-within:ring-2 focus-within:ring-teal-3">
      <label className="sr-only" htmlFor="search">
        Search
      </label>
      <input
        id="search"
        name="search"
        type="search"
        className="h-46 peer w-full bg-transparent p-10 pr-40 text-grey-8 ring-0 placeholder:text-grey-6 xs:w-[250px] md:w-[310px] xl:w-[335px]"
        placeholder={t('ui.search-placeholder')}
        value={props.address ?? ''}
        onChange={(e) => {
          props.onDone?.(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
          }
        }}
      />
      <SearchIcon className="pointer-events-none absolute right-16 top-14 stroke-grey-7 rect-14" />
    </fieldset>
  )
}

export default LocationSearch
